import { render, staticRenderFns } from "./UserDataDetail.vue?vue&type=template&id=2a436618&scoped=true&"
import script from "./UserDataDetail.vue?vue&type=script&lang=js&"
export * from "./UserDataDetail.vue?vue&type=script&lang=js&"
import style0 from "./UserDataDetail.vue?vue&type=style&index=0&id=2a436618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a436618",
  null
  
)

export default component.exports